import C7Init from "./commerce7/c7.js";
import Modules from "./modules/modules.js";

jQuery(document).ready(function($) {
    // new Modules().init();
    new C7Init().init();

    if (jQuery(".event-details .time").length) {
        const time = jQuery(".event-details .time").data("time");
        const eventTime = new Date(time * 1000);
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov" ,"Dec"];
        const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        let minute = eventTime.getMinutes();
        let hour = eventTime.getHours(); hour = (hour > 12) ? (hour - 12) : hour;
        let day = eventTime.getDate();
        const weekDay = eventTime.getDay();
        const month = eventTime.getMonth();
        const year = eventTime.getFullYear();

        minute = minute < 10 ? ("0" + minute) : minute;
        hour = hour < 10 ? ("0" + hour) : hour;
        day = day < 10 ? ("0" + day) : day;

        const timeString = "" + weekDays[weekDay] + ", " + months[month] + ". " + day + ", " + year + " @ " + hour + ":" + minute + " " + (eventTime.getHours() >= 12 ? "PM" : "AM");
        jQuery(".event-details .time").text(timeString);
    }
});